import styled from 'styled-components';

import Text from 'xpi-black-ui/Base/Typography/Text/styles';

export default styled.div`
  img {
    width: 100px;
  }

  ${Text} {
    display: block;
    margin-bottom: 20px;
  }
`;
